import {ResultDocument} from '../../../../commons/types/SearchResult'

export const getRechtsstand = (resultDocument: ResultDocument): Date | undefined => {
  const dateString = resultDocument.properties.rechtstand
  if (!dateString) {
    return undefined
  }
  return new Date(dateString)
}
